import styled, { css } from 'styled-components';
import { breakpointsMedia } from '@nubank/nuds-web/styles/breakpoints';
import { spacing } from '@nubank/nuds-web/styles/themeUtils';

export const TabContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: ${spacing('16x')} 0;

  ${breakpointsMedia({
    md: css`
      padding: ${spacing('32x')} 0;
      flex-direction: row;
    `,
  })}
`;

TabContent.displayName = 'TabContent';
